type NumberFormatRule = {
  /**
   * The pattern that matches each digit that needs a separator after it.
   * The number must be surrounded by brackets so it can be used in the replacement.
   */
  regex: RegExp,
  /**
   * The regex replacement that will use the match group 1 for the digit that will
   * get a separator
   */
  replacement: string,
};

/** Matches a digit when digits in groups of three follow. */
const thousandsPattern = /(-?\d)(?=(\d{3})+$)/g;

/** As above, but will only match if the number has more than 4 digits. */
const multipleThousandsPattern = /(?!^\d{1,4}$)(-?\d)(?=(\d{3})+$)/g;

const blankSeparator: NumberFormatRule = {
  regex: thousandsPattern,
  replacement: '$1\xa0',
};

const blankSeparatorMultiThousands: NumberFormatRule = {
  regex: multipleThousandsPattern,
  replacement: '$1\xa0',
};

const commaSeparator: NumberFormatRule = {
  regex: thousandsPattern,
  replacement: '$1,',
};

const languageFormats = {
  en: commaSeparator,
  de: blankSeparator,
  fr: blankSeparator,
  es: blankSeparatorMultiThousands,
};

export default class NumberFormatter {
  private readonly formatRule: NumberFormatRule;

  constructor(language) {
    this.formatRule = languageFormats[language] || blankSeparator;
  }

  formatNumber = (value: number): string => {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return '';
    }
    return Math.round(value).toString(10).replace(
      this.formatRule.regex, this.formatRule.replacement,
    );
  };
}
